module.exports = __webpack_public_path__ + "img/rider-express.82d0cb85.webp";